module.exports = __webpack_public_path__ + "static/media/microfono.6a06397f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Images/Volume/microfono.svg
// module id = 1855
// module chunks = 0